import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  activeTab = 'exist';
  userData: any = {};
  newUserData: any = {};

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  setActive = (val) => {
    this.activeTab = val;
  }

  closePopUp = () => {
    this.activeModal.close();
  }

  processForm = () => {

  }

  processRegForm = () => {

  }


}
